import { useMemo, useState } from 'react';
import { Col, Row } from 'react-grid-system';
import styled from 'styled-components';
import { RowSpacer } from '../atoms';
import { NormalFormTextArea, NormalFormTextField } from '../molecules/NormalFormFields';
import { useUserLanguage, useCreateCommunicationContext } from '@/customHooks';
import textsData from '@/textData/CreateCommunicationsTexts.json';

const Card = styled.div`
  background: ${({ theme }) => theme.colors.light};
  padding: 2rem;
  border-radius: ${({ theme }) => theme.border.radius.base};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
`;

const AvailableChars = styled.p`
  font-size: ${({ theme }) => theme.typography.fontSize.s6};
  color: ${({ theme }) => theme.colors.text};
  opacity: 0.6;
  text-align: right;
`;

const MESSAGE_LIMIT = 2000;

export const WriteCommunicationMessage = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;
  const { state, setTitle, setMessage, setButtonDisabled, setButtonEnabled } =
    useCreateCommunicationContext();

  const [availableChars, setAvailableChars] = useState(
    MESSAGE_LIMIT - (state.message?.length ?? 0),
  );

  const isValid = useMemo(
    () =>
      state.title.trim().length > 0 &&
      state.message.trim().length > 0,
    [state.title, state.message],
  );

  if (!isValid) setButtonDisabled();
  else setButtonEnabled();

  return (
    <Row justify="center">
      <Col md={8}>
        <Card>
          <Row>
            <Col>
              <NormalFormTextField
                label={texts.message.titleField.label}
                placeholder={texts.message.titleField.placeholder}
                value={state.title}
                onChange={(value) => setTitle(value ?? '')}
                required
              />
            </Col>
          </Row>
          <RowSpacer height={2} />
          <Row>
            <Col>
              <NormalFormTextArea
                label={texts.message.bodyField.label}
                placeholder={texts.message.bodyField.placeholder}
                value={state.message}
                onChange={(value) => {
                  const next = value ?? '';
                  if (next.length > MESSAGE_LIMIT) return;
                  setMessage(next);
                  setAvailableChars(MESSAGE_LIMIT - next.length);
                }}
                required
              />
              <AvailableChars>
                {availableChars} {texts.message.availableChars}
              </AvailableChars>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

